import { Actions } from "@client/actions";
import { type LoadPageSuccessActionData } from "@client/app/actions";
import { setCustomContent, setMetaTagContent, setOgMetaTagContent } from "@client/lib/misc";
import { type AppState } from "@client/types";
import { type ReduxAction } from "@client/types/ReduxAction";
import { type Dispatch, type MiddlewareAPI } from "redux";

export default (api: MiddlewareAPI<Dispatch<any>, AppState>) => (next) => (action: ReduxAction<any>) => {
  switch (action.type) {
    case Actions.LoadPageSuccess: {
      const data = action.data as LoadPageSuccessActionData;
      const meta = data.page.meta;

      document.head.querySelector("title")!.innerText = meta.title;

      setMetaTagContent("description", meta.description);
      setMetaTagContent("keywords", meta.keywords);
      setMetaTagContent("robots", meta.robots);

      setOgMetaTagContent("description", meta.description);
      setOgMetaTagContent("image", meta.imageUrl);
      setOgMetaTagContent("title", meta.title);
      setOgMetaTagContent("type", meta.type);

      setCustomContent("Body Code", document.body, false, meta.bodyCode);
      setCustomContent("Head Code", document.head, true, meta.headCode);
      setCustomContent("Footer Code", document.body, true, meta.footerCode);

      break;
    }
  }

  next(action);
};
